"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withContext = _interopRequireDefault(require("../../helpers/with-context"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _moduleModal = _interopRequireDefault(require("@eig-builder/module-modal"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

require("../../lang");

var ImagePickerHeader = function ImagePickerHeader(_ref) {
  var showBackButton = _ref.showBackButton,
      navigate = _ref.navigate,
      uploadOnly = _ref.uploadOnly,
      title = _ref.title,
      showClose = _ref.showClose,
      meta = _ref.meta,
      showAddImageButton = _ref.showAddImageButton,
      actions = _ref.actions,
      returnPage = _ref.returnPage;

  // const className = classNames('ip-header clearfix', {
  //   'back-and-close': showBackButton && showClose,
  //   'show-only-back': showBackButton === true && showClose === false,
  //   'show-only-close-mobile': showClose === true && showBackButton === false && MD(),
  //   'show-only-close': showClose === true && showBackButton === false && !MD()
  // })
  var getReturnPage = function getReturnPage() {
    if (returnPage) {
      return returnPage;
    }

    return uploadOnly ? 'my-images' : 'free-images';
  };

  var ButtonsToShow = (0, _toConsumableArray2["default"])(actions);

  if (showAddImageButton && !(0, _mobileDetectionHelper["default"])()) {
    ButtonsToShow.push( /*#__PURE__*/_react["default"].createElement("div", {
      className: "add-images-button"
    }, /*#__PURE__*/_react["default"].createElement(_compositionsButtonWithIcon["default"], {
      dataElementLabel: "image-selector--nav--add-image",
      dataElementLocation: _taggingHelper.DataElementLocations.NAV,
      dataElementId: "image-selector--nav--add-image",
      size: "medium",
      color: "primary",
      labelPosition: "after",
      icon: /*#__PURE__*/_react["default"].createElement(_Add["default"], null),
      onClick: function onClick(e) {
        return navigate(null, 'upload', {
          returnPage: 'my-images'
        });
      },
      tag: "",
      fullWidth: true,
      key: "add-image"
    }, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.addImages"
    }))));
  }

  if (showAddImageButton && (0, _mobileDetectionHelper["default"])()) {
    ButtonsToShow.push( /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      dataElementLabel: "image-selector--nav--add-image-mobile",
      dataElementLocation: _taggingHelper.DataElementLocations.NAV,
      dataElementId: "image-selector--nav--add-image-mobile",
      tag: "add-image-mobile-button",
      onClick: function onClick(e) {
        return navigate(null, 'upload', {
          returnPage: 'my-images'
        });
      },
      key: "add-image-mobile"
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "add_to_photos"
    })));
  }

  return /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header, null, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Alignment, null, showBackButton && /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header.Back, {
    onClick: function onClick() {
      return navigate(null, getReturnPage(), null);
    }
  })), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Alignment, {
    alignSelf: "center"
  }, /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header.Title, {
    title: title
  })), /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Alignment, {
    rightAligned: true
  }, ButtonsToShow, showClose && /*#__PURE__*/_react["default"].createElement(_moduleModal["default"].Header.Close, null)));
};

ImagePickerHeader.propTypes = {
  showBackButton: _propTypes["default"].bool,
  navigate: _propTypes["default"].func,
  uploadOnly: _propTypes["default"].bool,
  title: _propTypes["default"].any,
  showClose: _propTypes["default"].bool,
  meta: _propTypes["default"].object,
  showAddImageButton: _propTypes["default"].bool,
  actions: _propTypes["default"].array,
  returnPage: _propTypes["default"].string
};
ImagePickerHeader.defaultProps = {
  showBackButton: false,
  showClose: false
};

var _default = (0, _withContext["default"])(ImagePickerHeader);

exports["default"] = _default;